<template>
    <div class="flex w-full footer surface-100">
		<div class="center w-full py-2 px-3 xl:py-4 lg:py-3 md:py-3">
			<div class="flex flex-row align-items-center gap-3">
                <!-- <div class="flex mb-4">
                    <a v-if="deferredPrompt && isUserInGroup('admin')" @click="installPWA" 
                        class="text-white cursor-pointer">
                        Установить приложение
                    </a>
                </div> -->
                <div class="flex flex-row gap-2">
                    <!-- <Avatar size="small" label="U" shape="circle"  /> -->
                    <Button @click="go_tg" class="cursor-pointer" icon="pi pi-telegram" rounded severity="secondary" size="small"/>
                    <Button @click="go_inst" class="cursor-pointer" icon="pi pi-instagram" rounded severity="secondary" size="small"/>
                </div>
                <div class="flex">
                    <span class="text-600">
                        © pay-wave.co {{ get_version() }}
                    </span>
                </div>
                <div class="hidden xl:flex lg:flex md:flex">
                    <span class="text-600 cursor-pointer hover:underline hover:text-900" @click="goTo('/policy/')">
                        {{ buttons[lang_].policy }}
                    </span>
                </div>
                <div class="hidden xl:flex lg:flex md:flex">
                    <span class="text-600 cursor-pointer hover:underline hover:text-900" @click="goTo('/terms/')">
                        {{ buttons[lang_].terms }}
                    </span>
                </div>
                <div class="hidden xl:flex lg:flex md:flex">
                    <span class="text-600 cursor-pointer hover:underline hover:text-900" @click="goTo('/aml/')">
                        {{ buttons[lang_].aml }}
                    </span>
                </div>
                <div class="block" style="height:66px" v-if="hideHeader"></div>
			</div>
		</div>
	</div>
</template>

<script setup>
    import { ref, onMounted } from 'vue';
    const deferredPrompt = ref(null);
    const isAppInstalled = ref(false);

    onMounted(() => {
        // Проверка на наличие serviceWorker
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register('/service-worker.js')
            .then((registration) => {
                console.log('Service Worker registered with scope:', registration.scope);
            })
            .catch((error) => {
                console.log('Service Worker registration failed:', error);
            });
        }

        // Обработчик события beforeinstallprompt
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            deferredPrompt.value = e;
            console.log('beforeinstallprompt event fired');
        });

        // Обработчик события appinstalled
        window.addEventListener('appinstalled', () => {
            isAppInstalled.value = true;
            console.log('PWA was installed');
        });
        });

        // Функция для установки PWA
        const installPWA = () => {
            console.log('deferredPrompt', deferredPrompt);
            console.log('isAppInstalled', isAppInstalled);
        if (deferredPrompt.value) {
            deferredPrompt.value.prompt();
            deferredPrompt.value.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the A2HS prompt');
            } else {
                console.log('User dismissed the A2HS prompt');
            }
            deferredPrompt.value = null;
            });
        }
    };
</script>

<script>
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'
import Event from '@/assets/js/Event.js'

export default {
    name: 'footer',
    props: ['menu'],
    data() {
        return {
            buttons:  {
                ru:{
                    help: "Нужна помощь?",
                    policy: "Политика конфиденциальности",
                    terms: "Публичная оферта",
                    aml: "AML & KYC",
                },
                en:{
                    help: "Help is needed?",
                    policy: "Privacy Policy",
                    terms: "Public Offer",
                    aml: "AML & KYC",
                },               
            }, 
        }
    },
    computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        },
        hideHeader: function () {
            if(this.$route.name=='Transfer Details' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            if(this.$route.name=='AdmTransferDetail' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            if(this.$route.name=='Get Bill' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            if(this.$route.name=='Get Deal' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            if(this.$route.name=='PersonalDeal' && (this.screen_size=='sm' || this.screen_size=='xs')) return true
            return false
        },
        screen_size() { return this.$store.getters.StateScreenSize },
    },
    methods: {
        go_tg(){
            this.event.send('linkTg')
            window.open('https://t.me/pw_origin_bot', '_blank')
        },
        go_inst(){
            this.event.send('linkInst')
            window.open('https://instagram.com/pay.wave.co', '_blank')
        },
        goTo(path) {
            if(!path) return
            this.$router.push(path)
        },
        get_version() {
            var _connect = new Connect()
            return _connect.version
        },
        copy(text){
            this.helper.copy_clipboard(text)
            let title = (this.lang_=='ru') ? 'Скопировано' : 'Copied'
            this.showMess('success', title, text)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        isUserInGroup: function (type) { 
            return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
        this.event = new Event()
    },
}
</script>